/**
 * Pure mapping helpers for hydrating the application form from the server payload.
 *
 * These are intentionally framework-free so they can be unit tested without
 * mounting the (large, Inertia-coupled) PersonalInformationContent page.
 *
 * Why this exists (RAC-10236): `current_own_rent` and `previous_own_rent` are
 * real columns on the `applications` table and the controller exposes them at the
 * TOP LEVEL of the payload. The previous-address fields (previous_address_1, city,
 * etc.) live inside the `addresses` JSON column. The own/rent values must therefore
 * be read from the top level — reading `application.addresses.previous_own_rent`
 * returns undefined and silently wipes the applicant's saved answer on every
 * re-init, which blocked submission on the Review & Submit step.
 */

/**
 * Resolve the current/previous own-or-rent selections from the application payload.
 *
 * @param {object|null|undefined} application
 * @returns {{current_own_rent: (string|number), previous_own_rent: (string|number)}}
 */
export function resolveOwnRentFields(application) {
    return {
        current_own_rent: application?.current_own_rent ?? '',
        previous_own_rent: application?.previous_own_rent ?? '',
    };
}
